import React, { useMemo } from 'react';
import cx from 'classnames';

import { hexToRgb } from '../../../../util/color/hexToRgb';

interface CanvasPreviewProps {
  className?: string;
  backgroundColor?: string;
  opacity?: number;
}

export const CanvasPreview: React.FC<CanvasPreviewProps> = ({
  backgroundColor,
  opacity = 0,
  className,
  children,
}) => {
  const rbgaValue = useMemo(() => hexToRgb(backgroundColor), [backgroundColor]);

  return (
    <div
      className={cx('canvas-preview', className)}
      id="digitalCanvasBg"
      style={{
        backgroundColor: backgroundColor
          ? `rgba(${rbgaValue?.r}, ${rbgaValue?.g}, ${rbgaValue?.b}, ${parseFloat(
              (opacity / 100).toString()
            )})`
          : 'transparent',
      }}
    >
      {children}
    </div>
  );
};
